"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const dumblabel_1 = __importDefault(require("../../dumblabel"));
const textinput_1 = __importDefault(require("../../textinput/textinput"));
const status_1 = require("../../constants/status");
class FieldText extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            inputHasFocus: false
        };
        this.id = lodash_uniqueid_1.default('ftc_');
        this.handleFocus = e => {
            this.props.onFocus(e);
            this.setState({
                inputHasFocus: true
            });
        };
        this.handleBlur = e => {
            this.props.onBlur(e);
            this.setState({
                inputHasFocus: false
            });
        };
        this.handleChange = e => {
            this.props.onValueChange(e);
        };
    }
    render() {
        const { label, placeholder, value, inputRef, disabled, invalid, caution, valid, required, hideLabel, errorMessage, hideErrorMessage, dataCy } = this.props;
        const { inputHasFocus } = this.state;
        let status;
        if (invalid) {
            status = status_1.STATUS_INVALID;
        }
        else if (caution) {
            status = status_1.STATUS_CAUTION;
        }
        else if (valid) {
            status = status_1.STATUS_VALID;
        }
        else {
            status = null;
        }
        const labelProps = {
            forId: this.id,
            text: label,
            inputHasValue: !!value,
            inputHasFocus,
            status,
            hideLabel,
            required
        };
        const inputProps = {
            type: 'text',
            placeholder,
            id: this.id,
            handleFocus: this.handleFocus,
            handleBlur: this.handleBlur,
            handleChange: this.handleChange,
            value,
            inputRef,
            status,
            disabled,
            required,
            errorMessage,
            hideErrorMessage,
            dataCy
        };
        return (jsx_runtime_1.jsx(dumblabel_1.default, Object.assign({}, labelProps, { children: jsx_runtime_1.jsx(textinput_1.default, Object.assign({}, inputProps), void 0) }), void 0));
    }
}
exports.FieldText = FieldText;
FieldText.propTypes = {
    label: prop_types_1.default.string.isRequired,
    inputRef: prop_types_1.default.func,
    value: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    caution: prop_types_1.default.bool,
    valid: prop_types_1.default.bool,
    hideLabel: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    errorMessage: prop_types_1.default.string,
    onValueChange: prop_types_1.default.func.isRequired,
    onFocus: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    hideErrorMessage: prop_types_1.default.bool,
    dataCy: prop_types_1.default.string
};
FieldText.defaultProps = {
    inputRef: () => { },
    value: '',
    placeholder: '',
    disabled: false,
    invalid: false,
    caution: false,
    valid: false,
    required: false,
    hideLabel: false,
    errorMessage: '',
    onFocus: () => { },
    onBlur: () => { },
    hideErrorMessage: false,
    dataCy: 'atomic-fieldtext'
};
exports.default = FieldText;
//# sourceMappingURL=index.js.map